import type { ReactNode } from 'react';

import styles from './MetaDataList.module.css';

export interface MetaDataListProps {
  /** A list of key value pairs to display. The value is be a [ReactNode](https://reactnative.dev/docs/react-node). */
  items: Record<string, ReactNode>;
}

/** Represents a component of a list of key value pairs. */
export const MetaDataList = ({ items }: MetaDataListProps) => (
  <dl className={styles['meta-data-list']}>
    {Object.entries(items).map(([term, description]) => (
      <div key={term} className={styles['meta-data-list__item']}>
        <dt className={styles['meta-data-list__term']}>{term}</dt>
        <dd className={styles['meta-data-list__description']}>{description}</dd>
      </div>
    ))}
  </dl>
);
